@if (actions && actions.length > 0) {
  <div ngbDropdown placement="bottom-right">
    <span ngbDropdownToggle id="dropdownActions" class="btn btn-outline-primary" aria-haspopup="true"
        aria-expanded="false" (click)="$event.stopPropagation()">...</span>
    <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownActions">
      @for (action of actions || []; track $index) {
        <button class="dropdown-item"
            (click)="raiseOnAction($event, action, data)">{{action.value}}</button>
      }
    </div>
  </div>
}
